import request from '@/http/http';

export function homePageDataFunction(){
    return request({
        url: 'home/page/data',
        method: 'get'
    })
}